module.exports = __webpack_public_path__ + "img/bouton-daccueil.e81371f8.png";